
import WidgetSetting from './components/themes/WidgetSettingLight.css';
import WidgetSettingRow from './components/themes/WidgetSettingRowLight.css';
export default {
  WidgetSetting,
  WidgetSettingRow
};
